import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-[50vh] flex items-center justify-center p-8" data-testid="error-boundary">
          <div className="text-center max-w-md">
            <AlertTriangle className="w-10 h-10 mx-auto mb-4" style={{ color: '#E8A020' }} />
            <h2 className="text-lg font-bold mb-2" style={{ color: '#0D1B2A' }}>Something went wrong on this page</h2>
            <p className="text-sm mb-5" style={{ color: '#5C6B7A' }}>
              The rest of the platform is unaffected. Error: {String(this.state.error?.message || this.state.error).slice(0, 200)}
            </p>
            <button onClick={() => { this.setState({ error: null }); window.location.reload(); }}
              data-testid="error-boundary-reload"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-sm text-sm font-semibold text-white"
              style={{ background: '#1A4C7C' }}>
              <RotateCcw className="w-4 h-4" /> Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
